import { GraphQlRequestService } from '../../../api/graphql-request-service';
import { Domains } from '../../constants';
import { hashString, RoleId } from '../types';
import { CacheBehaviour } from '../types-graphql';
import { handleGQLErrors } from '../utils';
import { PermissionService } from './service';
import { AssignedPermission, AssignedPermissions, Permission } from './types';

export class GraphQlPermissionService implements PermissionService {
  constructor(
    readonly graphQlRequestService: GraphQlRequestService,
    readonly simulateRoleId: RoleId | null
  ) {}

  public getDeps = () => [
    hashString([...this.graphQlRequestService.getDeps()]),
  ];

  public listDirectPermissions = async (roleId: RoleId, domain?: Domains) => {
    const result = await handleGQLErrors(
      this.graphQlRequestService.graphQlSdk.directPermissions({
        roleId,
        simulateRole: this.simulateRoleId,
        cacheBehaviour: CacheBehaviour.SkipCacheBehaviour,
      })
    );
    const directPermissions: Array<AssignedPermission<Permission>> =
      result.directPermissions ?? [];
    const assignedPermissions = new AssignedPermissions(directPermissions);
    return domain
      ? assignedPermissions.validForAndNotGlobal(domain)
      : assignedPermissions;
  };

  public listAllPermissions = async (roleId: RoleId, domain?: Domains) => {
    const result = await handleGQLErrors(
      this.graphQlRequestService.graphQlSdk.allPermissions({
        roleId,
        simulateRole: this.simulateRoleId,
      })
    );
    const allPermissions: Array<AssignedPermission<Permission>> =
      result.allPermissions ?? [];
    const assignedPermissions = new AssignedPermissions(allPermissions);
    return domain
      ? assignedPermissions.validForAndNotGlobal(domain)
      : assignedPermissions;
  };
}
